module.exports = __webpack_public_path__ + "img/facebook_icon.ccb90176.svg";